import { useEffect, useState } from "react";
import axios from "axios";
import Lenis from "lenis";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { MarqueeRibbon } from "@/components/MarqueeRibbon";
import { ProductShowcase } from "@/components/ProductShowcase";
import { ProcessSection } from "@/components/ProcessSection";
import { CustomOrder } from "@/components/CustomOrder";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK_PRODUCT = {
    id: "el-cancerbero-001",
    name: "EL CÁNCERBERO 001",
    edition: "First Design — 1 of 1 Series",
    price: 4299.0,
    original_price: 8598.0,
    sale: "50% OFF — TILL 30.09.2026",
    image: "/images/el-cancerbero-001.jpg",
    sizes: ["US 7", "US 8", "US 9", "US 10", "US 11", "US 12", "US 13"],
    description: "Black base runner, hand spray-painted with a soccer ball motif, hexagonal net fade, crimson lightning-scratch accents and a blood-red inner lining.",
    details: [
        { label: "Base", value: "Black mesh runner" },
        { label: "Technique", value: "Hand spray paint + brush" },
        { label: "Finish", value: "Matte sealant, water resistant" },
        { label: "Edition", value: "1 of 1 — no replicas" },
    ],
};

export default function Home() {
    const [products, setProducts] = useState([FALLBACK_PRODUCT]);

    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    useEffect(() => {
        const focus = new URLSearchParams(window.location.search).get("focus");
        const target = focus ? `[data-testid="product-showcase-${focus}"]` : window.location.hash || null;
        if (!target) return;
        const t = setTimeout(() => {
            const el = document.querySelector(target);
            if (el) {
                if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
                else el.scrollIntoView({ behavior: "smooth" });
            }
        }, 900);
        return () => clearTimeout(t);
    }, []);

    useEffect(() => {
        axios
            .get(`${API}/products`)
            .then((r) => r.data.length && setProducts(r.data))
            .catch(() => {});
    }, []);

    return (
        <div id="top" data-testid="home-page" className="min-h-screen bg-vault-black text-stone-900">
            <Header />
            <main>
                <Hero product={products.find((p) => p.id === "el-cancerbero-001") || products[0]} />
                <MarqueeRibbon />
                {products.map((p, i) => (
                    <ProductShowcase key={p.id} product={p} index={i} total={products.length} />
                ))}
                <ProcessSection />
                <CustomOrder />
            </main>
            <Footer />
            <CartDrawer />
        </div>
    );
}
